import { Fragment } from "react";

const inline = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={i}>{part.slice(2, -2)}</strong> : <Fragment key={i}>{part.replace(/^_|_$/g, "")}</Fragment>
  );

export const Markdown = ({ text }) => {
  const blocks = [];
  let list = [];
  const flush = () => {
    if (list.length) blocks.push(<ul key={`ul${blocks.length}`}>{list}</ul>);
    list = [];
  };
  text.split("\n").forEach((raw, i) => {
    const line = raw.trim();
    if (!line) return flush();
    if (line.startsWith("#")) {
      flush();
      blocks.push(<h2 key={i}>{inline(line.replace(/^#+\s*/, ""))}</h2>);
    } else if (/^[-*]\s/.test(line)) {
      list.push(<li key={i}>{inline(line.slice(2))}</li>);
    } else {
      flush();
      blocks.push(<p key={i}>{inline(line)}</p>);
    }
  });
  flush();
  return <div className="prose-plan">{blocks}</div>;
};
